function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "2400",
  height: "2400",
  xmlns: "http://www.w3.org/2000/svg",
  overflow: "hidden",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 682h23v23H12z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 682h23v23H12z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "c"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 682h23v23H12z"
}))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)",
  transform: "translate(-12 -681)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#c)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M35 693.084v10.552c0 .75-.613 1.364-1.363 1.364H22.769C16.911 705 12 699.266 12 693.5c0-6.351 5.15-11.5 11.5-11.5 5.94 0 11.5 4.988 11.5 11.084zm-12.345 3.565h1.69v-1.613c0-2.17 3.014-1.306 3.014-4.531 0-4.718-7.718-4.755-7.718.441h1.747c.04-2.905 4.224-2.985 4.224-.422 0 2.477-2.957 1.497-2.957 4.493zm-.23 3.82h2.208v-2.246h-2.208z",
  fill: "#986CFC",
  fillRule: "evenodd"
}))))));